/**
 * Global helper functions for iodd-elementor-base
 * These functions are used by custom elements like ada-toggler
 */
window.coolHelperFunctions = {

  /**
   * Slide up animation (collapse)
   * @param {HTMLElement} target - Element to slide up
   * @param {number} new_duration - Animation duration in milliseconds
   */
  slideUp(target, new_duration){
    const duration = new_duration || 500
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.clientHeight + 'px';
    target.clientHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration + 1);
  },

  /**
   * Slide down animation (expand)
   * @param {HTMLElement} target - Element to slide down
   * @param {number} new_duration - Animation duration in milliseconds
   */
  slideDown(target, new_duration){
    const duration = new_duration || 500
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.clientHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.clientHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration + 1);
  },

  /**
   * Generates a unique ID
   * @returns {string} Random ID string
   */
  generateID(){
    return `_${Math.random().toString(36).substr(2, 9)}`
  },

  /**
   * Wraps an element in another element
   * @param {HTMLElement} el - Element to wrap
   * @param {string} wrapperTag - Tag name for wrapper element
   * @param {string} namespace - Optional namespace for createElementNS
   * @returns {HTMLElement} The wrapper element
   */
  wrap(el, wrapperTag, namespace = "") {
    let wrapper
    if(namespace){
      wrapper = document.createElementNS(namespace, wrapperTag)
    } else {
      wrapper = document.createElement( wrapperTag ? wrapperTag : 'div')  
    }
    el.parentNode.insertBefore(wrapper, el)
    wrapper.appendChild(el)
    return wrapper
  },

  /**
   * Check if user prefers reduced motion
   * @returns {boolean}
   */
  prefersReducedMotion(){
    const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
    return !!isReduced
  },

  /**
   * Debounce function calls
   * @param {Function} func - Function to debounce
   * @param {number} timeout - Debounce delay in milliseconds
   * @returns {Function} Debounced function
   */
  debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  },

  /**
   * Get URL parameter by key
   * @param {string} key - Parameter key to retrieve
   * @returns {string|null} Parameter value or null
   */
  getURLParam(key){
    var params = {}
    var parser = document.createElement('a')
    parser.href = window.location.href
    var query = parser.search.substring(1)
    var vars = query.split('&')
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      params[pair[0]] = decodeURIComponent(pair[1])
    }
    return typeof params[key] !== undefined ? params[key] : null
  }
}
